module.exports = "/assets/9f58ee9ef69d89f934fd701b612f5a69.png";